module.exports = __webpack_public_path__ + "img/soy.7dd1d76f.svg";